export default __webpack_public_path__ + "static/media/event-banner@3x.1a7de06c.png";